import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface User {
  email: string;
  emailVerified: boolean;
  name: string;
  group: string;
  userId: string;
}

interface UserState {
  userInfo: User | null;
}

const initialState: UserState = {
  userInfo: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.userInfo = action.payload;
    },
    clearUser: state => {
      state.userInfo = null;
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;

export default userSlice.reducer;
